import { render, staticRenderFns } from "./leaderboard.vue?vue&type=template&id=0b4fe084&scoped=true&"
import script from "./leaderboard.vue?vue&type=script&lang=js&"
export * from "./leaderboard.vue?vue&type=script&lang=js&"
import style0 from "./leaderboard.vue?vue&type=style&index=0&id=0b4fe084&lang=scss&scoped=true&"
import style1 from "./leaderboard.vue?vue&type=style&index=1&id=0b4fe084&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b4fe084",
  null
  
)

export default component.exports